<template>
  <footer class="site-footer">
    <div class="footer-background">
      <canvas id="waveCanvas" ref="waveCanvas"></canvas>
      <div class="footer-content">
        <div class="footer-left">
          <h2>MatChat株式会社</h2>
          <p class="copyright">&copy; {{ new Date().getFullYear() }} MatChat K.K. All rights reserved.</p>
        </div>
        <div class="footer-right">
          <h2>お問い合わせ</h2>
          <p>Email: support@matchat.co.jp</p>
          <p>Address: 〒150-0043 東京都渋谷区<br>道玄坂1丁目10番8号 渋谷道玄坂東急ビル2F-C</p>
        </div>
      </div>
    </div>
  </footer>
</template>

  
<script>
export default {
  name: 'FooterSection',
  data() {
    return {
      animationFrameId: null,
      dpr: 1,
    };
  },
  mounted() {
    this.drawWave();
    window.addEventListener('resize', () => {
      this.stopWave(); // Stop current animation
      this.resizeCanvas(this.$refs.waveCanvas);
      this.drawWave(); // Restart animation
    });
  },
  beforeUnmount() { 
    this.stopWave();
    window.removeEventListener('resize', this.resizeCanvas);
  },
  methods: {
    drawWave() {
      const canvas = document.getElementById('waveCanvas');
      const ctx = canvas.getContext('2d');
      this.resizeCanvas(canvas); // Initial resize

      const waveHeight = 10; // 波浪高度
      let speed = 0.05; // 波浪速度
      const waveLength = 250; // 波长
      const yOffset = waveHeight; // Y轴偏移量，调整以适应你的footer高度

      const animate = () => {
        this.animationFrameId = requestAnimationFrame(animate);

        // CSS ピクセル基準の論理サイズ（Windows の 125%/150% 表示でも正しく描画する）
        const width = canvas.width / this.dpr;
        const height = canvas.height / this.dpr;

        ctx.clearRect(0, 0, width, height);

        ctx.beginPath();
        // 波の下側を塗りつぶすため、キャンバス下端まで含めた閉じたパスにする。
        // こうしないと拡大表示時に境界のアンチエイリアスが黒い線として見える。
        ctx.moveTo(0, height);
        ctx.lineTo(0, yOffset);

        // 绘制波浪，使用 waveLength 调整波长影响
        for (let i = 0; i <= width; i++) {
          // 修改 Math.sin 的参数来让波浪倒置并且使用 waveLength
          ctx.lineTo(i, yOffset + Math.sin(i / waveLength + speed) * waveHeight);
        }

        ctx.lineTo(width, 0); // 修改终点为画布顶部
        ctx.lineTo(0, 0); // 完成闭合路径
        ctx.closePath();
        ctx.fillStyle = '#f6f9f6'; // 波浪颜色（上方セクションの背景色に合わせる）
        ctx.fill();
        speed += 0.01; // 调整这个值改变动画速度
      }

      animate();
    },

    stopWave() {
      cancelAnimationFrame(this.animationFrameId);
    },
    resizeCanvas(canvas) {
      // Windows の Chrome は 125%/150% 表示が既定のことが多く、devicePixelRatio を
      // 無視して 1:1 で描くと波の輪郭が補間されて黒い線に見える。実ピクセルで描く。
      const dpr = window.devicePixelRatio || 1;
      this.dpr = dpr;
      const cssHeight = 20;

      canvas.width = Math.ceil(window.innerWidth * dpr);
      canvas.height = Math.ceil(cssHeight * dpr);
      canvas.style.width = '100%';
      canvas.style.height = `${cssHeight}px`;

      const ctx = canvas.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
  },
};
</script>
  
  <style scoped>
.site-footer {
  overflow: hidden; /* 防止波浪动画溢出footer */
  position: relative;
  background-image: url('@/assets/footer.jpg');
  background-size: cover;
  background-position: center;
  text-align: center;
}

.footer-background {
  backdrop-filter: blur(10px);
}

/* canvas は inline 要素だとベースライン分の隙間ができ、Windows の拡大表示で
   下地の暗い背景が黒い線として覗く。block 化し、上に 1px ずらして塞ぐ。 */
#waveCanvas {
  display: block;
  width: 100%;
  margin-top: -1px;
  vertical-align: top;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  padding-left: 60px;
  padding-right: 60px;
  color: #ffffff; /* 保证文本可读性 */
}

.footer-left h2, .footer-left p, .footer-right h2, .footer-right p {
  margin: 8px;
}

.footer-right h2 {
  padding-top: -20px;
}

.footer-right p {
  text-align: left;
  margin-right: 00px; /* 根据需要调整 */
  margin-left: 00px;
}

@media (max-width: 600px) {
.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  color: #ffffff; /* 保证文本可读性 */
  font-size: 0.5rem;
}

.footer-left h2, .footer-left p, .footer-right h2, .footer-right p {
  margin: 8px;
}

}
</style>
  